import _extends from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _classCallCheck from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _defineProperty from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import styled from 'styled-components';
import styles from './ImageGallerySlider.style';
import Carousel from '../../molecules/Carousel';
import ImageTextCard from '../../molecules/ImageTextCard';
import Anchor from '../../atoms/Anchor';
import CarouselArrow from '../../atoms/CarouselArrow';
import componentAnalytics from '../../../constants/analyticsConstants';
var getMobileSettings = function getMobileSettings() {
  return {
    infinite: true,
    slidesToShow: 1,
    rows: 1,
    slidesPerRow: 1,
    arrows: true,
    speed: 500,
    dots: true,
    slidesToScroll: 1
  };
};
var getCarouselSettings = function getCarouselSettings(galleryData, tilesPerRow, sliderPrefix) {
  var mobileSettings = getMobileSettings();
  return _objectSpread({}, mobileSettings);
};
var ImageGalleryBlock = styled.section.withConfig({
  componentId: "sc-13ygsww-0"
})(["", ";"], styles);
var ImageGallerySlider = /*#__PURE__*/function (_React$Component) {
  _inherits(ImageGallerySlider, _React$Component);
  var _super = _createSuper(ImageGallerySlider);
  function ImageGallerySlider(props) {
    var _this;
    _classCallCheck(this, ImageGallerySlider);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "onSelectIndex", function (index) {
      _this.props.onSelectTile(index);
    });
    _this.onSelectIndex = _this.onSelectIndex.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(ImageGallerySlider, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        carouselType = _this$props.carouselType,
        galleryData = _this$props.galleryData,
        sliderPrefix = _this$props.sliderPrefix,
        tileClassName = _this$props.tileClassName,
        tilesPerRow = _this$props.tilesPerRow,
        srcSetSetting = _this$props.srcSetSetting;
      if (!galleryData[0]) return null;
      var carouselSettings = getCarouselSettings(galleryData, tilesPerRow, sliderPrefix);
      return __jsx(ImageGalleryBlock, {
        className: "nva-image-gallery-slider"
      }, galleryData.length && __jsx(Carousel, _extends({
        classes: {
          carousel: 'nva-image-gallery-slider__carousel',
          allTilesContainer: 'nva-image-gallery-slider__all-tiles-container'
        },
        styleType: carouselType
      }, carouselSettings, {
        prevArrow: __jsx(CarouselArrow, {
          type: "previous"
        }),
        nextArrow: __jsx(CarouselArrow, {
          type: "next"
        })
      }), galleryData.map(function (tileData, index) {
        var _tileData$title, _tileData$title2;
        return __jsx(Anchor, {
          className: "nva-image-gallery-slider__anchor",
          title: ((_tileData$title = tileData.title) === null || _tileData$title === void 0 ? void 0 : _tileData$title.trim()) || tileData.altText || 'Media tile',
          key: index,
          "data-analytics-type": componentAnalytics.miniGallery.analyticsType.TILES,
          "data-analytics-value": ((_tileData$title2 = tileData.title) === null || _tileData$title2 === void 0 ? void 0 : _tileData$title2.trim()) || tileData.altText,
          "data-analytics-variation": "",
          onClick: function onClick() {
            return _this2.onSelectIndex(index);
          },
          tabindex: "0",
          role: "button",
          onKeyPress: function onKeyPress(e) {
            if (e.code === 'Enter') {
              _this2.onSelectIndex(index);
              return;
            }
            if (e.code === "Space") {
              _this2.onSelectIndex(index);
              return;
            }
          }
        }, __jsx(ImageTextCard, {
          styleType: "gallery",
          isGallery: true,
          className: "nva-image-gallery-slider__text-card ".concat(tileClassName),
          imageSource: tileData.imgSrc,
          imageAltText: tileData.altText,
          imageTitle: tileData.title || tileData.altText,
          imageCaption: tileData.imageCaption,
          mediaType: tileData.mediaType,
          key: index,
          imageClassName: "nva-image-gallery-slider__text-card-image ".concat(tileData.appliedClass),
          srcSetSetting: srcSetSetting
        }));
      })));
    }
  }]);
  return ImageGallerySlider;
}(React.Component);
ImageGallerySlider.defaultProps = {
  galleryData: '',
  sliderPrefix: '',
  tileClassName: ''
};
export default styled(ImageGallerySlider).withConfig({
  componentId: "sc-13ygsww-1"
})(["", ";"], styles);
export { ImageGallerySlider as ImageGalleryVanilla };